/*@flow*/
import type { Element } from 'react';
import React, { useState } from 'react';
import truncate from 'underscore.string/truncate';

export default ({
  value,
  limit,
}: {
  limit: number,
  value: string,
}): React$Node => {
  const [showingMore, setShowingMore] = useState(false);

  if (limit > value.length) {
    return value;
  }
  if (showingMore) {
    return [
      value,
      ' ',
      <button key={1} onClick={() => setShowingMore(false)}>
        (less)
      </button>,
    ];
  }
  return [
    truncate(value, 100),
    ' ',
    <button key={1} onClick={() => setShowingMore(true)}>
      (more)
    </button>,
  ];
};
